import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const ExpandableGrid = styled(Grid)<{ $isVisible?: boolean }>`
    overflow: hidden;
    height: auto;

    ${(props) => props.$isVisible === false && `margin-top: -41px; height: 0;`};
`;
